import styled from '@emotion/styled';
import { css } from '@emotion/react';
import * as tokens from '@tokens';

const DatePickerStyles = css`
  /* DayPicker styles */

  .DayPicker {
    display: inline-block;
    ${tokens.text('caption')};
    width: 256px;
  }

  .DayPicker-wrapper {
    position: relative;

    flex-direction: row;
    padding: ${tokens.spacer.x2};

    user-select: none;
  }

  .DayPicker-Months {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .DayPicker-Month {
    display: table;
    border-spacing: 0;
    border-collapse: collapse;
    user-select: none;
    margin: 0;
  }

  .DayPicker-NavBar {
  }

  .DayPicker-Caption {
    display: table-caption;
    text-align: center;
    height: ${tokens.spacer.x4};
    margin: 0;
    padding: 0;
  }

  .DayPicker-Caption > div {
    color: ${tokens.color.text_default};
    line-height: ${tokens.spacer.x4};
  }

  .DayPicker-Weekdays {
    display: table-header-group;
    margin: 0;
  }

  .DayPicker-WeekdaysRow {
    display: table-row;
  }

  .DayPicker-Weekday {
    display: table-cell;
    height: ${tokens.spacer.x4};
    width: ${tokens.spacer.x4};
    color: ${tokens.color.text_light};
    text-align: center;
    font-size: 10px;
    line-height: ${tokens.spacer.x4};
    padding: 0;
  }

  .DayPicker-Weekday abbr[title] {
    border-bottom: none;
    text-decoration: none;
  }

  .DayPicker-Body {
    display: table-row-group;
  }

  .DayPicker-Week {
    display: table-row;
  }

  .DayPicker-Day {
    display: table-cell;
    height: ${tokens.spacer.x4};
    width: ${tokens.spacer.x4};
    border-radius: ${tokens.radius.m};
    line-height: ${tokens.spacer.x4};
    text-align: center;
    cursor: pointer;
    color: ${tokens.color.text_light};
    &:focus {
      ${tokens.focus()};
    }
    padding: 0;
  }

  .DayPicker--interactionDisabled .DayPicker-Day {
    cursor: default;
  }

  /* Default modifiers */

  .DayPicker-Day--today {
    color: ${tokens.color.text_default};
    font-weight: 600;
  }

  .DayPicker-Day--outside {
    color: ${tokens.color.text_disabled};
  }

  .DayPicker-Day--disabled {
    color: ${tokens.color.text_disabled};
    cursor: default;
  }

  /* Example modifiers */

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled) {
    position: relative;
    background-color: ${tokens.color.link};
    color: ${tokens.color.text_default_inverse};
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):hover {
    background-color: ${tokens.color.link_alt};
  }

  .DayPicker:not(.DayPicker--interactionDisabled)
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(
      .DayPicker-Day--selected
    ):hover {
    background-color: ${tokens.color.neutral_100};
    color: ${tokens.color.link};
  }

  /* DayPickerInput */

  .DayPickerInput-OverlayWrapper {
    position: relative;
  }

  .DayPickerInput-Overlay {
    position: absolute;
    left: 0;
    z-index: 2;
    top: ${tokens.spacer.x1};
    background: white;
    ${tokens.elevation(2)};
    border: 1px solid ${tokens.color.ui_border};
    border-radius: ${tokens.radius.m};
  }
`;

export const DatePickerContainer = styled.div`
  ${DatePickerStyles};
  width: 100%;
`;

export const DateRangePickerContainer = styled.div`
  ${DatePickerStyles};

  .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end) {
    background-color: ${tokens.color.bg_active} !important;
    color: ${tokens.color.text_light};
    border-radius: 0;
  }
  display: flex;
  gap: ${tokens.spacer.x2};
  position: relative;
  width: 100%;

  .DayPickerInput {
    width: calc(50% - ${tokens.spacer.x1});
  }
`;
